import {Controller} from "@hotwired/stimulus"
import {get} from '@rails/request.js'
import TomSelect from "tom-select"
import Rails from "@rails/ujs";

export default class extends Controller {
    static values = {url: String, callback: String, textfield: String, allowcreate: Boolean}

    connect() {
        console.log('Hello World from TomSelect')
        console.log(this.allowcreateValue)
        console.log(this.allowcreateValue == true)
        var config = {
            valueField: 'value',
            onType: (value) => this.on_change(value),
            onDropdownClose: (dropdown) => this.item_selected(dropdown),
            onItemRemove: (dropdown) => this.item_removed(dropdown),
            onOptionAdd: (value, data) => this.onOptionAdd(value, data),
            closeAfterSelect: true,
            //se lectOnTab: true,
            create: (this.allowcreateValue == true ? true : false),
            load: (q, callback) => this.search(q, callback)
        }
        new TomSelect(this.element, config)
    }

    onOptionAdd(value, data) {
        console.log("-->" + data)
        data['value'] = -1
    }

    on_change(value) {
        if (this.textfieldValue != '' && value != '') {
            console.log('Value Change TomSelect "' + value + '"')
            console.log(" #" + this.textfieldValue)
            document.querySelector("#" + this.textfieldValue).value = value;
        }
    }

    item_selected(dropdown) {
        var x = this.element;
        var i = x.selectedIndex;
        // console.log('Item Selected TomSelect')
        // console.log('Value Change TomSelect "' + x.options[i].value + '"')

        if (x.options[i].value != "0" && this.textfieldValue != '') {
            // console.log('Item Cleared TomSelect')
            document.querySelector("#" + this.textfieldValue).value = x.options[i].text;
        }
        if (this.callbackValue != '') {
            // console.log('Form Fired TomSelect')
            document.body.style.cursor = 'wait'
            this.element.form.submit();
            document.body.style.cursor = 'default'
        }
    }

    item_removed(dropdown) {

        if (this.textfieldValue != '') {
            // document.querySelector("#" + this.textfieldValue).value = '';
        }
        if (this.callbackValue != '' && this.callbackValue.indexOf('set_assignment') == -1) {
            Rails.fire(this.element.form, 'submit');
        }
    }

    async search(q, callback) {
        const response = await get(this.urlValue, {
            query: {search: q},
            responseKind: 'json'
        })

        if (response.ok) {
            const list = await response.json
            callback(list)
        } else {
            console.log(response)
            callback()
        }
    }
}